import React, { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useAuthState } from "../../Context";
import axios from "axios";
import { useTheme } from "@mui/material/styles";
import MainLayout from "../Common/MainLayout";
import { fetchTableauVizUrl } from "../../api/dashboardService";
import { fetchAuthSession } from "aws-amplify/auth";

function TableauComponent() {
  const theme = {
    tableauEmbedView: {
      minHeight: 501,
      minWidth: 900,
    },
  };
  // const { id } = useParams();
  const { state } = useLocation();
  console.log("state", state);
  const view_viewUrlName = state.view_viewUrlName;
  const workbook_contentUrl = state.workbook_contentUrl;
  const site_contentUrl = state.site_contentUrl;

  // Use environment variable for Tableau server URL if available
  const tableauBaseUrl = process.env.REACT_APP_TABLEAU_URL;
  console.log("tableauBaseUrl", tableauBaseUrl);
  const serverName = new URL(tableauBaseUrl).hostname;
  console.log("serverName", serverName);
  const ref = useRef(null);
  let tableauViz = null;

  const initViz = async () => {
    let vizUrlWithTicket = "";
    try {
      const session = await fetchAuthSession();
      const token = session.tokens.idToken;
      if (!token) throw new Error("User token is missing. Please log in.");
      vizUrlWithTicket = await fetchTableauVizUrl(
        {
          site_contentUrl,
          workbook_contentUrl,
          view_viewUrlName,
        },
        token
      );
    } catch (error) {
      console.error(
        "An error occurred while fetching the Tableau viz URL:",
        error
      );
      return;
    }
    console.log("Fetched Tableau Viz URL:", vizUrlWithTicket);
    const options = {
      hideTabs: true,
      hideToolbar: true,
      // width: Math.max(theme.tableauEmbedView.minWidth, window.innerWidth),
      // height: Math.max(
      //   theme.tableauEmbedView.minHeight,
      //   window.innerHeight - theme.navbarHeight
      // ),
      width: window.innerWidth, // Adjust width dynamically
      height: window.innerHeight - 60, // Adjust height dynamically
      onFirstInteractive: () => {
        console.log("Run this code when the viz has finished loading.");
        // const width = Math.max(theme.tableauEmbedView.minWidth, window.innerWidth)
        // const height = Math.max(
        //   theme.tableauEmbedView.minHeight,
        //   window.innerHeight - theme.navbarHeight
        // );
        // console.log("width", width, "height", height);
        // console.log("tableauViz.width", tableauViz.width, "tableauViz.height", tableauViz.height)
        // var sheet = tableauViz.getWorkbook().getActiveSheet();
        // sheet.changeSizeAsync(
        // {"behavior": "EXACTLY", "maxSize": { "height": height, "width": width }})
        // .then(tableauViz.setFrameSize(parseInt(width, 10), parseInt(height, 10)));
      },
    };

    // Check if a viz already exists in the div, if so, clean it up
    if (tableauViz !== null) {
      tableauViz.dispose();
    }

    // Initialize the Tableau dashboard
    tableauViz = new window.tableau.Viz(ref.current, vizUrlWithTicket, options);
  };

  //TODO: Refactor this
  const handleResize = () => {
    const width = Math.max(theme.tableauEmbedView.minWidth, window.innerWidth);
    const height = Math.max(
      theme.tableauEmbedView.minHeight,
      window.innerHeight - theme.navbarHeight
    );
    tableauViz.setFrameSize(parseInt(width, 10), parseInt(height, 10));
    console.log("resizing window to width: ", width, " height: ", height);
    // if (tableauViz) {
    //   var sheet = tableauViz.getWorkbook().getActiveSheet();
    //   sheet.changeSizeAsync(
    //     {"behavior": "EXACTLY", "maxSize": { "height": height, "width": width }}
    //   )
    //   .then(tableauViz.setFrameSize(parseInt(width, 10), parseInt(height, 10)));
    // }
  };

  useEffect(() => {
    // Initialize the viz
    const initializeViz = async () => {
      await initViz();
    };

    initializeViz();

    window.addEventListener("resize", handleResize);

    // Cleanup on component unmount
    return () => {
      console.log("Running cleanup for Tableau Viz");
      if (tableauViz !== null) {
        try {
          tableauViz.dispose(); // Attempt to dispose of the Tableau visualization
          console.log("Tableau Viz disposed");
        } catch (error) {
          console.error("Error disposing Tableau Viz:", error);
          // Handle any errors that occur during the dispose, if necessary
        }
      }
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <MainLayout>
      <div ref={ref}></div>
    </MainLayout>
  );
}

export default TableauComponent;
